// Alpine
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import anchor from '@alpinejs/anchor'
import Alpine from "alpinejs";

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// GSAP
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap
window.ScrollTrigger = ScrollTrigger

// Splide
import Splide from "@splidejs/splide";
window.Splide = Splide

// Custom
import counter from './counter.js'
import scrollyAnimation from "./scrollyAnimation.js";

// Alpine
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(anchor)
window.Alpine = Alpine;

Alpine.data('counter', counter)
Alpine.data("scrollyAnimation", scrollyAnimation);

Alpine.start();
